import Vue from 'vue'

const Coms = [
    {
        // 统一弹框
        name: 'm-drawer',
        component: () => import('@/components/drawer/drawer.vue')
    },
    {
        // 统一查询
        name: 'm-formBox',
        component: () => import('@/components/formBox/formBox.vue')
    },
]

const vueComs = () => {
    Coms.forEach((item) => {
        return Vue.component(item.name, item.component)
    })
}
export default vueComs



// WEBPACK FOOTER //
// ./src/components/index.js